export default __webpack_public_path__ + "static/media/paraquedas.5adabc97.mp3";